// extracted by mini-css-extract-plugin
export var card = "carouselD-module--card--B-suI";
export var content = "carouselD-module--content--n2jwH";
export var country = "carouselD-module--country--JP-AT";
export var name = "carouselD-module--name--xZayM";
export var pictD = "carouselD-module--pictD--59Q6p";
export var swiperContainer = "carouselD-module--swiperContainer--ykcf5";
export var wrapper = "carouselD-module--wrapper--tDaQR";